import axios from 'axios'

export default class homeApi {
  // 留资接口
  static homeClueFunc(data) {
    return axios.post('/high/home/clue', data)
  }

  static homeGetBannerList(data) {
    return axios.get('/high/home/getBannerList', {params: data})
  }

  // 获取底部数据
  static homeGetBottom() {
    return axios.get('/high/home/getBottom')
  }

  static homeGetHomeContent() {
    return axios.get('/high/home/getHomeContent')
  }
}




// WEBPACK FOOTER //
// ./src/api/homeApi.js